export default import.meta.ROLLDOWN_FILE_URL_RGei5JJ4zpyRRcYRqD5PPw